import { apiGetRecordPatient , apiGetRecordPatientPublic} from "helpers/api/records";
import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_GRAPH_URINE,
  GET_GRAPH_URINE_PUBLIC,
  actGetGraphUrineFailed,
  actGetGraphUrineSuccess,
} from "store/actions/graph";
import { showToastError } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetGraphUrine(action) {
  try {
    const response = yield call(apiGetRecordPatient, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actGetGraphUrineSuccess(response));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
      // showToastSuccess(
      //     'success',
      // )
    }
  } catch (error) {
    yield put(actGetGraphUrineFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

function* doGetGraphUrinePublic(action) {
  try {
    const response = yield call(apiGetRecordPatientPublic, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actGetGraphUrineSuccess(response));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
      // showToastSuccess(
      //     'success',
      // )
    }
  } catch (error) {
    yield put(actGetGraphUrineFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchGetGraphUrine() {
  yield takeLatest(GET_GRAPH_URINE, doGetGraphUrine);
}

export function* watchGetGraphUrinePublic() {
  yield takeLatest(GET_GRAPH_URINE_PUBLIC, doGetGraphUrinePublic);
}
